import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { Calendar } from "../../../../ui/molecules/calendar";
import { MadfarmInput } from "../../../../ui/molecules/input/newInput";
import MultiSelectCheckbox from "../../../../ui/molecules/multiSelectCheckbox";
import { ProtocolSearch } from "../../../../ui/molecules/ProtocolSearch";
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static";
import TextArea from "../../../../ui/molecules/textArea";
import { RowActivityMultiSelect, activityOptions, global_standards, global_standards_options_functions, normativa, regioniListOperativeAreas } from "../../../../utils";
import { FunctionCreation, resetFunctionsCreateForm, resetFunctionsValidationStatus, setAreeOperative, setDateNote, setEnding, setFunction, setMinisterialNote, setNote, setProtocolMinisterialRequestId, setProtocolRequestId, setRowsActivityGG, setScheme, setStarting, validateFunctionCreation } from "../slice";
import { RowActivity } from "./rowActivity";


interface Props {
    close: () => void;
}

export function FunzioniPopupAdd(props: Props) {
    const dispatch = useAppDispatch()
    const functionsState = useAppSelector(state => state.PMFunctions)
    const [selectedArea, setSelectedArea] = useState<{ label: string; value: string }[]>([]);
    const [typeScheme, setTypeScheme] = useState<string | undefined>('');
    const [rows, setRows] = useState<RowActivityMultiSelect[]>([
        { ggStandard: "", ggIfaOption: "", startingActivity: "", endingActivity: "" },
    ]);

    useEffect(() => {
        if (functionsState.functionValidateStatus === 'successfully') {
            dispatch(resetFunctionsValidationStatus())
            dispatch(FunctionCreation(functionsState.functionRequest))
            props.close();
            dispatch(resetFunctionsCreateForm())
        }
    }, [functionsState.functionValidateStatus])

    const handleChangeGG = (
        index: number,
        field: keyof RowActivityMultiSelect,
        value: string
    ) => {
        const updatedRows = rows.map((row, rowIndex) => {
            if (rowIndex === index) {
                return {
                    ...row,
                    [field]: value
                };
            }
            return row;
        });

        setRows(updatedRows);
        dispatch(setRowsActivityGG(updatedRows));
    };

    return (
        <Fragment>
            <div className="p-6 bg-white flex flex-col gap-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Funzione"
                        placeholder={'Seleziona funzione...'}
                        options={activityOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setFunction(newValue))
                        }}
                        defaultValue={functionsState.functionRequest.assignedFunction}
                        value={functionsState.functionRequest.assignedFunction}
                        error={functionsState.functionsErrors.assignedFunction}
                        errorLabel="Specificare funzione"
                        noOptionsMessage={""}
                    />
                    <Calendar
                        label="Data inizio"
                        selected={functionsState.functionRequest.startingFunction}
                        onChange={(date) => {
                            dispatch(setStarting(format(new Date(date), 'yyyy-MM-dd')))
                        }}
                    />
                    <Calendar
                        label="Data fine"
                        selected={functionsState.functionRequest.endingFunction}
                        onChange={(date) => {
                            dispatch(setEnding(format(new Date(date), 'yyyy-MM-dd')))
                        }}
                    />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Norma"
                        noOptionsMessage=""
                        placeholder={'Norma'}
                        options={normativa}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            setTypeScheme(newValue)
                            dispatch(setScheme(newValue))
                        }
                        }
                        value={functionsState.functionRequest.norm}
                        errorLabel="Specificare norma"
                    />
                    <MultiSelectCheckbox
                        label="Aree Operative"
                        onChange={(e) => {
                            setSelectedArea(e.value)
                            dispatch(setAreeOperative(e.value))
                        }}
                        value={selectedArea}
                        option={regioniListOperativeAreas}
                        placeholder="Aree Operative"
                        selectAllLabel="Italia"

                    />
                </div>
                {
                    typeScheme === 'NORMA_BIO' &&
                    <div>
                        <RowActivity />
                    </div>
                }
                {
                    typeScheme === 'GLOBAL_GAP' &&
                    <div>
                        <div className="grid grid-cols-2 gap-4">
                            <MadfarmStaticSelect
                                label="Attività"
                                placeholder={'Seleziona Attività...'}
                                options={global_standards}
                                onChange={(e) => {
                                    if (e) {
                                        //@ts-ignore
                                        const newValue = e.value ? e.value : null
                                        handleChangeGG(0, "ggStandard", newValue);
                                    }
                                }}
                                //onChange={(value) => dispatch(setFunction(value))}
                                defaultValue={rows[0]['ggStandard']}
                                value={rows[0]['ggStandard']}
                                noOptionsMessage={""}
                            />
                            <MadfarmStaticSelect
                                label="Opzione di certificazione"
                                placeholder={'Seleziona Categoria...'}
                                options={global_standards_options_functions}
                                onChange={(e) => {
                                    if (e) {
                                        //@ts-ignore
                                        const newValue = e.value ? e.value : null
                                        handleChangeGG(0, "ggIfaOption", newValue);
                                    }
                                }}
                                defaultValue={rows[0]['ggIfaOption']}
                                value={rows[0]['ggIfaOption']}
                                noOptionsMessage={""}
                            />
                            <Calendar
                                label="Data Inizio"
                                selected={rows[0]['startingActivity'] ? new Date(rows[0]['startingActivity']) : null}
                                onChange={(date) => {
                                    handleChangeGG(0, "startingActivity", format(new Date(date), 'yyyy-MM-dd'))
                                }}
                            />
                            <Calendar
                                label="Data fine"
                                selected={rows[0]['endingActivity'] ? new Date(rows[0]['endingActivity']) : null}
                                onChange={(date) => {
                                    handleChangeGG(0, "endingActivity", format(new Date(date), 'yyyy-MM-dd'))
                                }}
                            />
                        </div>
                    </div>
                }

                <div className="border-t border-neutral-200 pt-2">
                    <p className="text-md font-semibold uppercase tracking-widest text-brandPrimary-600">Gestione Autorizzazioni Ministeriali</p>
                </div>
                <span className="text-sm text-left font-semibold uppercase tracking-widest text-brandPrimary-600">Protocollo Richiesta Codex (Partenza)</span>
                <div className="grid grid-cols-1 gap-6">
                    <ProtocolSearch
                        type="departure"
                        errorLabel={functionsState.functionsErrors.protocolIdRequestDeparture ? 'Protocollo mancante' : undefined}
                        onSelect={(value) => dispatch(setProtocolRequestId(value))}
                    />
                </div>
                <span className="text-sm text-left font-semibold uppercase tracking-widest text-brandPrimary-600">Protocollo Codex Ricevuta Ministero (Entrata)</span>
                <div className="grid grid-cols-1 gap-6">
                    <ProtocolSearch
                        type="entry"
                        errorLabel={functionsState.functionsErrors.ministerialReceivedProtocolId ? 'Protocollo mancante' : undefined}
                        onSelect={(value) => dispatch(setProtocolMinisterialRequestId(value))}
                    />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <MadfarmInput
                        label="Nota Ministeriale"
                        placeholder="Nota Ministeriale"
                        onChangeText={(text) => dispatch(setMinisterialNote(text))}
                        value={functionsState.functionRequest.ministerialNote}
                        defaultValue={functionsState.functionRequest.ministerialNote}
                        error={functionsState.functionsErrors.ministerialNote}
                        supportingText={functionsState.functionsErrors.ministerialNote ? "Inserire nota" : undefined}
                    />
                    <Calendar
                        label="Data nota"
                        selected={functionsState.functionRequest.noteDate}
                        onChange={(date) => {
                            dispatch(setDateNote(format(new Date(date), 'yyyy-MM-dd')))
                        }}
                    />
                </div>
                <div className="grid grid-cols-1 gap-4">
                    <TextArea
                        label="Note"
                        onChangeText={(text) => dispatch(setNote(text))}
                        value={functionsState.functionRequest.note}
                        defaultValue={functionsState.functionRequest.note}
                    />
                </div>
                <div className="flex justify-end gap-2 pt-4 border-t border-neutral-200">
                    <ButtonComponent
                        size="md"
                        variant="outline"
                        iconPosition="off"
                        label="Annulla"
                        color="gray"
                        onClick={() => {
                            props.close();
                        }}
                    />
                    <ButtonComponent
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Aggiungi"
                        color="orange"
                        onClick={() => {
                            dispatch(validateFunctionCreation(functionsState.functionRequest))
                            //dispatch(FunctionCreation(functionsState.functionRequest))
                        }}
                    />
                </div>
            </div>
        </Fragment>
    )
}